import React, {useState, useCallback} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import ViewExpense from "./ViewExpense"
//import history from "./Routes"
import apiBaseUrl from './API'

// import {useHistory} from 'react-router-dom';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useHistory
  } from "react-router-dom";
import history from './history'

import axios from 'axios';

const useStyles = makeStyles({
  table: {
    minWidth: 500,
    tableBodyHeight: "500px"
  }
});

export default function Example1(props) {

  const classes = useStyles();

  const data = [[]]
  const [responseData, setResponseData] = useState({});
  const [hasError, setErrors] = useState(false);
  const [oc, setOc] = useState(false);
  const [rowId, setRowId] = useState(-1);
  const [prevId, setPrevId] = useState();
  // const history = useHistory();

  //const handleOnClick = useCallback(() => history.push('/test1'), [history]);

  const handleOnClick = useCallback(() => history.push('/test1' ), [history]);

  // const handleOnClick = useCallback((id) => 
  // console.log('ID', id),
  // history.push('/id'), [history]);

  // const handleOnClick = (id) => {
  //   history.push('/test1')
  //   console.log("ID ", id)
  //   // return 
  //   //  {<ViewExpense/>}
    
  
  // };

  // const handleOnClick = () => (
  //   <Route render={({ history}) => (
  //     <button
  //       type='button'
  //       onClick={() => { history.push('/new-location') }}
  //     >
  //       Click Me!
  //     </button>
  //      )} />
  //      )
  const handleEdit = (values) => {
   
    console.log("HE ", values)
    setOc(true)
    setRowId(values[11])
  };

  const handleApprove = (values) => {
    console.log('VAL ', values)

     var payload={
        "id": values[17],
        "status":"Approved",
      }
    axios.put(apiBaseUrl+ "/action", payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("Expense successfull");
       }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });

  };

  const handleReject = (values) => {
    console.log('VAL ', values)
    var payload={
        "id": values[11],
        "status":"Reject",
      }
    axios.put(apiBaseUrl+ "/action", payload)
    .then(function (response) {
      console.log(response);
      if(response.data.code === 200){
         console.log("Expense successfull");
       
      }
      else{
        console.log("some error ocurred",response.data.code);
      }
    })
    .catch(function (error) {
      console.log(error);
    });

  };

  React.useEffect(() => {
    async function fetchData() {
        const res = await fetch(apiBaseUrl+"/getExpense/?userid="+props.userid+"&role="+props.role);
        res
        .json()
        .then(res => setResponseData(res))
        .catch(err => setErrors(err));
    }

    fetchData();
  },[]);

  
   console.log("RAW ",responseData)
   for(var i=0; i < responseData.length; i++) {
    var na = []
    console.log("RAW12121212 ",responseData[i].id)

    na.push(responseData[i].name)
    na.push(responseData[i].cname)
    na.push(responseData[i].project_name)
    na.push(responseData[i].project_code)
    na.push(responseData[i].location)
    na.push(responseData[i].typeOfBike)
    na.push(responseData[i].bikeKM)
    na.push(responseData[i].bike)
    na.push(responseData[i].car)
    na.push(responseData[i].bus)
  //  na.push(responseData[i].flight)
    na.push(responseData[i].train)
    na.push(responseData[i].food)
    na.push(responseData[i].hotel)
    na.push(responseData[i].total)
    na.push(new Date(responseData[i].e_date).toLocaleDateString('pt-PT'))
    na.push(responseData[i].status)
    na.push(responseData[i].description)
    na.push(responseData[i].e_id)

    data.push(na)

    na = [];
    }
  console.log('UU ',data);
 
  return (
      <div>
 
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>User Name</TableCell>

            <TableCell>Customer Name</TableCell>
            <TableCell align="right">Project Name</TableCell>
            <TableCell align="right">Project Code</TableCell>
            <TableCell align="right">Location</TableCell>
            <TableCell align="right">Bike Type</TableCell>
            <TableCell align="right">KM</TableCell>
            <TableCell align="right">Bike Expense</TableCell>
            <TableCell align="right">Local</TableCell>
            <TableCell align="right">Bus</TableCell>
            <TableCell align="right">Train</TableCell>
            <TableCell align="right">Food</TableCell>
            <TableCell align="right">Hotel</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align="right">Date</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">Description</TableCell>

            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row[0]}>
              <TableCell component="th" scope="row">
                {row[0]}
              </TableCell>
              <TableCell align="right">{row[1]}</TableCell>
              <TableCell align="right">{row[2]}</TableCell>
              <TableCell align="right">{row[3]}</TableCell>
              <TableCell align="right">{row[4]}</TableCell> 
              <TableCell align="right">{row[5]}</TableCell> 
              <TableCell align="right">{row[6]}</TableCell> 
              <TableCell align="right">{row[7]}</TableCell> 
              <TableCell align="right">{row[8]}</TableCell> 
              <TableCell align="right">{row[9]}</TableCell> 
              <TableCell align="right">{row[10]}</TableCell> 
              <TableCell align="right">{row[11]}</TableCell> 
              <TableCell align="right">{row[12]}</TableCell> 
              <TableCell align="right">{row[13]}</TableCell> 
              <TableCell align="right">{row[14]}</TableCell> 
              <TableCell align="right">{row[15]}</TableCell> 
              <TableCell align="right">{row[16]}</TableCell> 
              {/* <TableCell align="right">{row[17]}</TableCell>  */}


              <TableCell align="right">
               {props.role =="tl" ?   
               <div>
                <Button variant="outlined" color="primary" onClick={() => handleApprove(row)}>
                Verify 
             </Button> 
            <Button variant="outlined" color="secondary" onClick={() => handleReject(row)}>
                Reject 
             </Button> 
             </div> : 
              <div>
              <Button variant="outlined" color="primary" onClick={() => handleApprove(row)}>
              Approve 
           </Button> 
              <Button variant="outlined" color="secondary" onClick={() => handleReject(row)}>
                  Reject 
              </Button> 
           </div>   } 

              {/* {props.role =="admin" ? 
              <Button variant="outlined" color="primary" onClick={() => handleApprove(row)}>
                   Verify 
                </Button> 
               <Button variant="outlined" color="secondary" onClick={() => handleReject(row)}>
                   Reject 
                </Button> } */}
                {/* <Button aria-label="View" onClick={() => handleStatusChange(row)}> */}

                {/* <Button aria-label="View" onClick={() => test()}> */}
                {/* <Button variant="outlined" color="primary" onClick={() => handleOnClick(row)}>
                    Test 
                 </Button>
            */}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
            {console.log("** ",{rowId}.rowId)}
     {  {rowId}.rowId != -1 ? <ViewExpense details = {rowId}/> : "" }
           {/* { setOc(false)} */}
    </div>
        

 );

}



// WEBPACK FOOTER //
// ./src/Example1.js